module.exports = __webpack_public_path__ + "linea-music-10.6db7e51310cba57aeb54.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/linea-icons/fonts/linea-music-10.svg
// module id = ../../../../../src/assets/scss/icons/linea-icons/fonts/linea-music-10.svg
// module chunks = styles